import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-arrange-icon',
  templateUrl: './layout-layout-arrange.component.html'
})
export class LayoutLayoutArrangeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
